<template>
    <div class="sidebar" data-color="orange" data-background-color="black" :style="sidebarStyle">
        <div class="logo">
            <a href="#" class="simple-text logo-mini">
                <img src="../../../assets/images/navitas_icon.png" alt="NG" height="30">
            </a>
            <a href="#" class="simple-text logo-normal">
                <img src="../../../assets/images/navitas_logotype_white.png" class="md-image" height="30" alt="">
            </a>
            <div class="navbar-minimize">
                <md-button id="minimizeSidebar" class="md-round md-just-icon md-transparent" @click="minimizeSidebar">
                    <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
                    <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
                </md-button>
            </div>
        </div>
        <div class="sidebar-wrapper" ref="sidebarScrollArea">
            <slot></slot>
            <md-list class="nav">
                <slot name="links">
                    <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
                        <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index"
                                      :link="subLink">
                        </sidebar-item>
                    </sidebar-item>
                </slot>
            </md-list>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapGetters} from "vuex";
import Jwt from 'vue-jwt-decode';
import AuthService from "../../services/AuthService";

export default {
    name: "sidebar",
    computed: {
        ...mapGetters('app', {
            authenticatedInitData: 'getAuthenticatedInitData'
        }),
        sidebarStyle() {
            return {
                backgroundImage: `url(${require('@/assets/images/login.jpg')})`
            };
        },
        sidebarLinks() {
            let links = [
                {name: 'Dashboard', path: this.$enums.RoutePathEnum.DASHBOARD, children: [], icon: 'dashboard'},
            ];

            if (!this.authenticatedInitData.user || !this.authenticatedInitData.user.scopes) {
                return links;
            }

            const scopes = this.authenticatedInitData.user.scopes;

            if (scopes.includes('manage-users')) {
                links.push(this.usersMenuItems);

                if (process.env.VUE_APP_FEATURE_AVALIABLE_RESELLERS === 'true') {
                    links.push(this.resellerMenuItems);
                }

                if (process.env.VUE_APP_FEATURE_AVALIABLE_ORGANIZATIONS === 'true') {
                    links.push(this.organizationsMenuItems);
                }

                links.push(this.deletedAreaMenuItems);
            }
            if (scopes.includes('admin')) {
                links.push(this.systemSettingsMenuItems);
            }

            return links;
        },
        routePath() {
            return this.$route.path;
        },
        usersMenuItems() {
            return {
                name: 'Users',
                path: this.$enums.RoutePathEnum.USERS,
                children: [],
                icon: 'supervisor_account'
            }
        },
        resellerMenuItems() {
            return {
                name: 'Resellers',
                path: this.$enums.RoutePathEnum.RESELLERS,
                children: [
                    {
                        name: 'View',
                        path: this.$enums.RoutePathEnum.RESELLERS,
                        children: []
                    },
                    {
                        name: 'Create',
                        path: this.$enums.RoutePathEnum.RESELLERS_CREATE,
                        children: []
                    },
                ], icon: 'store'
            }
        },
        deletedAreaMenuItems() {
            let deletedElements = [];

            deletedElements.push({
                name: 'Users',
                path: this.$enums.RoutePathEnum.DELETED_USERS,
                children: [],
                icon: 'supervisor_account'
            })
            if (process.env.VUE_APP_FEATURE_AVALIABLE_ORGANIZATIONS === 'true') {
                deletedElements.push({
                    name: 'Organizations',
                    path: this.$enums.RoutePathEnum.DELETED_ORGANIZATIONS,
                    children: [],
                    icon: ''
                })
            }

            return {
                name: 'Deleted',
                path: '',
                children: deletedElements,
                icon: 'delete'
            }
        },
        organizationsMenuItems(){
            return {
                name: 'Organizations',
                path: this.$enums.RoutePathEnum.RESELLERS,
                children: [
                    {
                        name: 'View',
                        path: this.$enums.RoutePathEnum.ORGANIZATIONS,
                        children: []
                    },
                    {
                        name: 'Create',
                        path: this.$enums.RoutePathEnum.ORGANIZATION_CREATE.replace(':tab', ''),
                        children: []
                    },
                ],icon: ''
            };
        }, systemSettingsMenuItems() {
            return {
                name: 'System settings',
                path: '',
                children: [
                    {
                        name: 'Maintenance mode',
                        path: this.$enums.RoutePathEnum.MAINTENANCE_MODE,
                        children: []
                    },
                ],
                icon: 'settings'
            }
        }
    }
    ,
    methods: {
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        }
        ,
        authenticatedInit() {
            this.setGlobalLoadingState(true);

            this.$api.authenticatedInit().then(({data}) => {
                this.accessToken = AuthService.getAccessToken();

                let decodedToken = Jwt.decode(this.accessToken);
                if (decodedToken && decodedToken.scopes) {
                    this.setAuthenticatedInitData({
                        ...data,
                        user: {
                            ...data.user,
                            scopes: decodedToken.scopes
                        }
                    });
                } else {
                    this.setAuthenticatedInitData(data);
                }
            }).finally(() => {
                this.setGlobalLoadingState(false);
            });
        },
        ...mapMutations('app', {
            setGlobalLoadingState: 'setGlobalLoadingState',
            setAuthenticatedInitData: 'setAuthenticatedInitData',
        }),
    },
    mounted() {
        this.authenticatedInit();
    }
    ,
    watch: {
        routePath(path) {
            if (path === this.$enums.RoutePathEnum.DASHBOARD) {
                this.authenticatedInit();
            }
        }
    }
    ,
    provide() {
        return {
            autoClose: true,
        };
    }
    ,
    beforeDestroy() {
        if (this.$sidebar.showSidebar) {
            this.$sidebar.showSidebar = false;
        }
        this.$bus.off('init');
    }
    ,
    created() {
        this.$bus.on('init', () => this.authenticatedInit());
    }
    ,
    data() {
        return {
            accessToken: null
        }
    }
}
;
</script>
<style lang="scss">
.sidebar {
    overflow-x: hidden !important;
}

@media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu {
        display: none;
    }
}
</style>
